import { render, staticRenderFns } from "./Rates.vue?vue&type=template&id=c9941bb8&scoped=true&lang=html&"
import script from "./Rates.vue?vue&type=script&lang=js&"
export * from "./Rates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9941bb8",
  null
  
)

export default component.exports